import * as tslib_1 from "tslib";
// SideEffect - can't be tested because of the timeout
import { Logger } from "../Logger";
/**
 * ErrorLogger is used inside {ErrorBoundary} component
 * @extends Logger
 */
var ErrorLogger = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorLogger, _super);
    function ErrorLogger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Method log sets timeout with stringified error object so it will be executed outside of
     * the callstack of the react component thus captured from our logger in the responsive project and send it to Kibana
     * @param {Object} err object describing the error and callstack
     */
    ErrorLogger.prototype.log = function (err) {
        setTimeout(function () {
            throw new Error(JSON.stringify(err));
        }, 0);
    };
    return ErrorLogger;
}(Logger));
export { ErrorLogger };
//# sourceMappingURL=ErrorLogger.js.map